import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { map, takeUntil } from 'rxjs/operators';
import { Observable, Subject, of } from 'rxjs';
import { CurrencyService, CurrencyType } from '@services/currency.service';
import { ISupportedTokens } from '@http/interfaces/supported-token';
import { TokenService } from '@http/token.service';

const arrayTikerTokensToShow = ['COINDEPO'];

export interface IStripedObject {
  ticker: string;
  listing_price: number;
  balance_currency: number
}

@Component({
  selector: 'app-striped-account-status',
  templateUrl: './striped-account-status.component.html',
  styleUrls: ['./striped-account-status.component.scss'],
})
export class StripedAccountStatusComponent implements OnInit, OnDestroy {
  private destroyed$ = new Subject<void>();

  @Input() defaultData!: any;

  tokensForShow!: Array<any>;

  totalBalance$ = of(100);
  currency$: Observable<CurrencyType>;

  constructor(
    private currencyService: CurrencyService,
    private tokenService: TokenService,
  ) {
    this.currency$ = this.currencyService.currentCurrency$
  }

  ngOnInit(): void {
    this.tokenService.cachedSupportedTokens$.pipe(
      takeUntil(this.destroyed$),
      map((tokens: ISupportedTokens[]) => 
        tokens
          .filter(token => arrayTikerTokensToShow.includes(token.binance_ticker))
          .map(token =>({
            ticker: token.binance_ticker,
            listing_price: token.listing_price,
            balance_currency: 100,
            image: token.image
          }))
      )
    ).subscribe((tokens: IStripedObject[]) =>  {
        if (tokens.length) {
          this.tokensForShow = tokens;
        } else {
          this.tokensForShow = this.defaultData;
        }
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete()
  }
}
